import { Component, Input, OnInit, Output, forwardRef, EventEmitter, AfterViewInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, NgModel, Validator, AbstractControl } from '@angular/forms';
import { EvaluationCriteriaDto } from '@shared/service-proxies/service-proxies';
import * as _ from 'lodash';

@Component({
    selector: 'criteria-selection',
    templateUrl: './criteria-selection.component.html',
    styleUrls: ['./criteria-selection.component.css'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CriteriaSelectionComponent), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => CriteriaSelectionComponent), multi: true },
    ]
})

export class CriteriaSelectionComponent implements OnInit, ControlValueAccessor, Validator {

    @Input() criterias: EvaluationCriteriaDto[] = [];
    @Input() required = false;
    @Output() onModelChange = new EventEmitter();
    @Input() criteriastate = false;

    selectedCriteriaHint = '';
    model = 0;
    private onChange: (m: any) => void;
    private onTouched: (m: any) => void;

    constructor() {
    }

    ngOnInit(): void {
        setTimeout(() => {
            if (this.model !== 0) {
                this.selectedCriteriaHint = this.criterias[this.model - 1].description;
            }
        });
    }

    showHint(id) {
        if (id !== 0) {
            this.selectedCriteriaHint = this.criterias[id - 1].description;
        }
    }
    setSelectedCriteria(id: number) {
        if (id !== this.model) {
            this.onChange(id);
            this.model = id;
            this.onModelChange.emit(this.model);
        }
    }
    resetHint() {
        //if (this.model !== 0) {
        //  this.selectedCriteriaHint = this.criterias[this.model - 1].description;
        //  }

        this.selectedCriteriaHint = this.model !== 0 ? this.criterias[this.model - 1].description : "";
    }

    writeValue(value: number): void {
        if (value) {
            this.model = value;
        }
    }
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    validate(c: AbstractControl) {
        if (this.required && !c.value) {
            return {
                required: true
            };
        }
        return null;
    }

    criteriaIsSelected(id) {
        return this.model == id ? true : false;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/criteria-selection/criteria-selection.component.ts